import { useEffect } from 'react';

export interface ChatBridge {
  has: (messageId: string) => boolean;
  jumpTo: (messageId: string) => void;
  reply: (messageId: string, attachmentId?: string) => void;
  canDelete: (messageId: string) => boolean;
  requestDeleteAttachment: (messageId: string, attachmentId: string) => void;
}

const bridges = new Map<string, Set<ChatBridge>>();

export function useRegisterChatBridge(ticketId: string, bridge: ChatBridge): void {
  useEffect(() => {
    let set = bridges.get(ticketId);
    if (!set) bridges.set(ticketId, (set = new Set()));
    set.add(bridge);
    return () => {
      set.delete(bridge);
      if (set.size === 0) bridges.delete(ticketId);
    };
  }, [ticketId, bridge]);
}

export function findChatBridge(ticketId: string, messageId: string): ChatBridge | undefined {
  for (const b of bridges.get(ticketId) ?? []) if (b.has(messageId)) return b;
  return undefined;
}
